import { Box, Button, Card, CardContent, CardHeader, TextField, Typography, Alert } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useState } from "react";
import api from "../services/api";

export default function ForgotPasswordPage() {
  const theme = useTheme();
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault(); setMsg(null); setErr(null); setLoading(true);
    try { await api.post('/auth/forgot-password', { email }); setMsg('If an account exists, a reset link has been sent.'); }
    catch (e:any){ setErr(e?.response?.data?.message || 'Failed to request reset'); }
    finally { setLoading(false); }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', px: 3 }}>
      <Card sx={{ maxWidth: 500, width: '100%', borderRadius: 3, boxShadow: 8 }}>
        <CardHeader title={<Typography variant="h5" fontWeight={900}>Forgot Password</Typography>} />
        <CardContent>
          {msg && <Alert severity="success" sx={{ mb: 2 }}>{msg}</Alert>}
          {err && <Alert severity="error" sx={{ mb: 2 }}>{err}</Alert>}
          <form onSubmit={submit} className="space-y-4">
            <TextField label="Email" type="email" fullWidth required value={email} onChange={(e)=>setEmail(e.target.value)} />
            <Button type="submit" variant="contained" disabled={loading} fullWidth>Send Reset Link</Button>
          </form>
          <Typography variant="body2" sx={{ mt: 2 }}>Remembered it? <a href="/login" className="text-blue-700 hover:underline">Back to login</a></Typography>
        </CardContent>
      </Card>
    </Box>
  );
}

